import React from "react";

// `namesPlaceholder` / `locationPlaceholder` — the editor's preview stands a
// quiet line in for names or a location the couple hasn't entered yet.
const ProjectDetailHero = ({
  id,
  location,
  partner_one,
  partner_two,
  namesPlaceholder = null,
  locationPlaceholder = null,
  ...rest
}) => {
  const firstPartner = (partner_one ?? "").trim();
  const secondPartner = (partner_two ?? "").trim();
  const firstPartnerIsShorter = firstPartner.length <= secondPartner.length;

  const firstLine = firstPartnerIsShorter ? `${firstPartner} &` : firstPartner;
  const secondLine = firstPartnerIsShorter
    ? secondPartner
    : `& ${secondPartner}`;

  return (
    <header id={id} className="section _60" {...rest}>
      <div className="container hero-center realisa">
        <div className="pad-15">
          {namesPlaceholder ? (
            <h1 className="heading-9vw invitation-placeholder">{namesPlaceholder}</h1>
          ) : (
            <h1 className="heading-9vw">
              <span style={{ display: "block" }}>{firstLine}</span>
              <span style={{ display: "block" }}>{secondLine}</span>
            </h1>
          )}
        </div>
        {locationPlaceholder ? (
          <h2 className="made-28 invitation-placeholder">{locationPlaceholder}</h2>
        ) : (
          <h2 className="made-28">{location}</h2>
        )}
      </div>
    </header>
  );
};

export default ProjectDetailHero;
